/**
 * Compatibility re-export for the recap CLI, which now lives in its own
 * dependency-light package so CI does not install the full framework graph.
 */
export * from "@agent-native/recap-cli";
